import { Box, Card, Divider, Stack, Typography } from "@mui/material";
import { Inventory2 } from "@mui/icons-material";
import { Dimension } from "../../types";
import { useTranslation } from "../../../../hooks/useTranslation";
import { SectionHeader } from "../../../../components/ui/SectionHeader";

type Props = {
  dimensions: {
    length?: Dimension;
    width?: Dimension;
    height?: Dimension;
    weight?: Dimension;
  };
  totalDesi?: number;
  estimatedCost?: number;
};

export const PackageInfoCard = ({
  dimensions,
  totalDesi,
  estimatedCost,
}: Props) => {
  const { translate } = useTranslation("pages.orderDetails");

  return (
    <Card
      elevation={0}
      sx={{
        p: 2.5,
        backgroundColor: (theme) => theme.palette.customBackground.box,
      }}
    >
      <SectionHeader
        icon={<Inventory2 sx={{ fontSize: 20, color: "primary.main" }} />}
        title={translate("packageInfo.title")}
        color="primary"
      />
      <Divider sx={{ my: 2 }} />
      <Stack spacing={1}>
        <Box display="flex">
          <Box width={140}>
            <Typography variant="body2" fontWeight={500}>
              {translate("packageInfo.dimensions")}
            </Typography>
          </Box>
          <Typography variant="body2">
            {dimensions.length?.value} x {dimensions.width?.value} x{" "}
            {dimensions.height?.value} {dimensions.height?.unit}
          </Typography>
        </Box>

        <Box display="flex">
          <Box width={140}>
            <Typography variant="body2" fontWeight={500}>
              {translate("packageInfo.weight")}
            </Typography>
          </Box>
          <Typography variant="body2">
            {dimensions.weight?.value} {dimensions.weight?.unit}
          </Typography>
        </Box>

        <Box display="flex">
          <Box width={140}>
            <Typography variant="body2" fontWeight={500}>
              {translate("packageInfo.desi")}
            </Typography>
          </Box>
          <Typography variant="body2">{totalDesi}</Typography>
        </Box>
        <Box display="flex">
          <Box width={140}>
            <Typography variant="body2" fontWeight={500}>
              {translate("packageInfo.warehouseCost")}
            </Typography>
          </Box>
          <Typography variant="body2">
            {estimatedCost && `${estimatedCost} $`}
          </Typography>
        </Box>
      </Stack>
    </Card>
  );
};
